import React from "react";
import { RiPhoneFill, RiMap2Line } from "react-icons/ri";
import { MdEmail } from "react-icons/md";

import "./Contact.css";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <div className="contact-us" id="contact">
      <div className="contact-details">
        <div className="details">
          <h1>Contact Details</h1>
          <h5>
            <i>
              <RiMap2Line />
            </i>
            470 Lucy Forks, Patriciafurt, YC7B 3UT
          </h5>
          <h5>
            <i>
              <RiPhoneFill />
            </i>
            <a href="(123) 123-7899">(123) 123-7899</a>
          </h5>

          <div className="mailist">
            <p>
              <i>
                <MdEmail />
              </i>
              Support: <a href="mail@demolink.org">mail@demolink.org</a>
            </p>
            <p>
              <i>
                <MdEmail />
              </i>
              Marketing: <a href="mail@demolink.org">mail@demolink.org</a>
            </p>
            <p>
              <i>
                <MdEmail />
              </i>
              Career: <a href="mail@demolink.org">mail@demolink.org</a>
            </p>
          </div>
        </div>
        <div className="contact-form">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;
